import type { ReactNode } from "react";
import { useLocale } from "@/context/LanguageContext";

/** Card shell with a title and an optional header action (e.g. a toggle). */
export function ChartCard({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {action}
      </div>
      {children}
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div className="flex h-[260px] items-center justify-center">
      <div className="h-full w-full animate-pulse rounded bg-muted" />
    </div>
  );
}

export function ChartEmpty() {
  const { t } = useLocale();
  return (
    <div className="flex h-[260px] items-center justify-center text-sm text-muted-foreground">
      {t("analytics.noData")}
    </div>
  );
}
